<template lang="html">
  <list-template ref="list-template" actionUrl="carShow/business/findBusiness.action" :queryParams="searchInfo">
    <template slot="search">
      <el-input v-model="searchInfo.keyword" style="width:300px;" placeholder="商家名称 / 对接人电话 / 对接人姓名 / 地址"></el-input>
      <el-button type="primary" @click="$refs['list-template'].search()">搜索</el-button>
      <el-button @click="$router.push({name:'添加车展商家', params: { carShowInfoId:searchInfo.carShowInfoId }})" type="primary">上架新商家</el-button>
    </template>
    <template slot="item" scope="scope">
      <el-card v-for="data in scope.datas">
        <el-row>
          <el-col :span="3">
            <img :src="baseUrl+data.coverImage" style="width:120px;height:120px;"></img>
          </el-col>
          <el-col :span="16">
            <h4><b>{{data.name}}</b> <el-tag size="mini">{{data.type}}</el-tag><el-tag style="margin-left:10px;" v-if="data.del==1" size="mini" type="danger">已删除</el-tag></h4>
            <div>公司地址：{{data.address}}</div>
            <div>对接人员：{{data.management}} {{data.phone}}</div>

            <div>上架人员：{{data.createEmployee|defaultFilter}} {{data.createTime | dateFormat}}</div>

            <div style="color:#999999">
              {{data.uvCount}} 人 浏览 {{data.pvCount}} 次 |
              {{data.callUserCount}} 人拨打 {{data.callPhoneCount}} 次 |
              {{data.clueCount}} 条询底价 |
              已上架商品 {{data.productCount}} 个 | 活动 {{data.activityCount}} 个
            </div>
          </el-col>

          <div>
            <el-button @click="$router.push({name:'保存车展商家', params: { id: data.id }})" type="text">修改</el-button>
            <el-button @click="updateSort(data)" type="text">排序</el-button>
            <el-button
                v-if="data.del==0"
                v-confirm
                confirm-text="确认删除此商家？"
                :confirm-data="data"
                @onConfirm="deleteBusiness" type="text">删除商家</el-button>

            <el-button
                v-else
                v-confirm
                confirm-text="确认恢复此商家？"
                :confirm-data="data"
                @onConfirm="recoveryBusiness" type="text">恢复商家</el-button>
            <el-button @click="$router.push({name:'车展商品', params: { businessId: data.id }})" type="text">上架商品</el-button>
            <el-button @click="$router.push({name:'车展活动', params: { businessId: data.id }})" type="text">上架活动</el-button>
          </div>
          <div>
            <el-button @click="copyBusinessUrl(data.shareUrl)" type="text">复制商家主页链接</el-button>
          </div>
        </el-row>
      </el-card>
    </template>
  </list-template>
</template>

<script>
import ListTemplate from '@/components/ListTemplate'
import CarExhibitionModel from '@/framework/models/CarExhibitionModel'
import Config from '@/framework/configs/Config'
export default {
  name: 'car-exhibition-business-manager',
  components: {
    ListTemplate
  },
  data: function () {
    return {
      baseUrl: Config.imageUrl,
      searchInfo: {
        carShowInfoId: null,
        status: 0,
        keyword: null
      }
    }
  },
  created: function () {
    let params = this.$route.params
    this.searchInfo.carShowInfoId = params.carShowInfoId
  },
  activated: function () {
    let params = this.$route.params
    this.searchInfo.carShowInfoId = params.carShowInfoId

    this.$refs['list-template'].search()
  },
  methods: {
    recoveryBusiness: function (data) {
      let _this = this
      let params = {
        businessId: data.id
      }

      let listener = {
        success: function (dataInfo) {
          window.location.reload()
        }
      }

      CarExhibitionModel.recoveryBusiness(_this, params, listener)
    },
    deleteBusiness: function (data) {
      let _this = this
      let params = {
        businessId: data.id
      }

      let listener = {
        success: function (dataInfo) {
          window.location.reload()
        }
      }

      CarExhibitionModel.deleteBusiness(_this, params, listener)
    },
    copyBusinessUrl: function (url) {
      let _this = this
      const h = _this.$createElement
      let input = h('input', {
        style: 'color: teal',
        class: 'el-input__inner',
        attrs: {
          value: url
        }
      }, 'VNode')

      _this.$msgbox({
        title: '复制商家主页链接推广',
        message: h('p', null, [
          input
        ]),
        showCancelButton: true,
        confirmButtonText: '复制',
        cancelButtonText: '取消'
      }).then(action => {
        if (action === 'confirm') {
          input.elm.select()
          document.execCommand('Copy') // 执行浏览器复制命令
          _this.$message({
            message: '复制成功！',
            type: 'success'
          })
          done()
        } else {
          done()
        }
      })
    },
    updateSort: function (data) {
      let h = this.$createElement

      let elInput = h('input', { class: 'el-input__inner', attrs: { type: 'number', value: data.sortNumber } }, data.sortNumber)
      this.$msgbox({
        title: '设置排序值',
        message: h('p', null, [
          elInput,
          h('div', { style: 'color:red' }, '排序值越大越靠前')
        ]),
        showCancelButton: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            let _this = this
            let params = {
              id: data.id,
              sortNumber: elInput.elm.value
            }

            let listener = {
              success: function (dataInfo) {
                done()
                window.location.reload()
              }
            }

            CarExhibitionModel.updateBusinessSortValue(_this, params, listener)
          } else {
            done()
          }
        }
      })
    }
  }
}
</script>

<style lang="css">
</style>
